import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";

import RecruitmentOverview from "./index";
import RecruitmentView from "./view";
import { FaMagnifyingGlass } from "react-icons/fa6";

const recruitmentHrRoutes = [	
    generateCRUDRoutes({
        mainTitle: "Recruitment Overview",
        basePath: "recruitment-overview",
        mainComponent: <RecruitmentOverview />,
        layout: "/console",
        icon: <FaMagnifyingGlass className="icon-item" />,
        subTitle:"Hiring Pipeline",
        detailTitle: "",
        viewComponent: <RecruitmentView />,
        level:4,
        moduleId: 0,
    })
]

export default recruitmentHrRoutes;